import React, { Component } from 'react'
import PropTypes from 'prop-types'

import CloseButton from '../../../../../../../../../../components/CloseButton'

import './style.scss'

export default class DeleteCell extends Component {
    static propTypes = {
        groupId: PropTypes.string.isRequired,
        memberId: PropTypes.string,
        onDeleteMember: PropTypes.func.isRequired,
    }

    handleOnDeleteMember = () => {
        const { onDeleteMember, memberId, groupId } = this.props

        onDeleteMember(groupId, memberId)
    }

    render() {
        const { memberId } = this.props
        return (
            <div className={'group-table-delete-cell'}>
                {memberId && <CloseButton onClick={this.handleOnDeleteMember} pad={2} size={14} />}
            </div>
        )
    }
}
